export type ProjectFinancialsTabs = {
	DETAILS: string;
	RATES_AND_INTERNAL_COST?: string;
	REVENUE_RECOGNITION?: string;
	TASK_REPORT?: string;
	BREAKDOWN?: string;
	EXPENSES?: string;
	INVOICING?: string;
};

export type ProjectFinancialsTabOptions = {
	hasFinancials: boolean;
	hasCostAccess: boolean;
	hasRevenueAccess: boolean;
	tracksRevenue: boolean;
	showCost: boolean;
	showRevenueRecognition: boolean;
	showTaskBreakdown: boolean;
	showInvoicing: boolean;
};

export const getProjectFinancialsTabs = ({
	hasFinancials,
	hasCostAccess,
	hasRevenueAccess,
	tracksRevenue,
	showCost,
	showRevenueRecognition,
	showTaskBreakdown,
	showInvoicing,
}: ProjectFinancialsTabOptions): ProjectFinancialsTabs => {
	let tabs: ProjectFinancialsTabs = {
		DETAILS: 'project_budget.details',
	};

	if (hasCostAccess || hasRevenueAccess) {
		tabs = {
			...tabs,
			RATES_AND_INTERNAL_COST: tracksRevenue
				? showCost
					? 'project_budget.rates_and_internal_cost'
					: 'common.rates'
				: 'project_budget.internal_cost',
		};
	}

	if (showRevenueRecognition) {
		tabs = {
			...tabs,
			REVENUE_RECOGNITION: 'project_budget.revenue_recognition',
		};
	}

	if (showTaskBreakdown && hasFinancials) {
		tabs = {
			...tabs,
			TASK_REPORT: 'project_budget.task_breakdown',
			BREAKDOWN: 'project_budget.breakdown',
		};
	}

	if (hasFinancials && (hasCostAccess || hasRevenueAccess)) {
		tabs = {
			...tabs,
			EXPENSES: 'project_budget.expenses',
		};
	}

	if (hasFinancials && showInvoicing) {
		tabs = {
			...tabs,
			INVOICING: 'common.invoicing',
		};
	}

	return tabs;
};

// The page renders through a switch on these values, so an undefined tab would match the first
// case whose tab the viewer doesn't have. Anything not in tabs falls back to Details.
export const getProjectFinancialsTab = (tabs: ProjectFinancialsTabs, tabKey: string | null): string =>
	(tabKey && tabs[tabKey as keyof ProjectFinancialsTabs]) || tabs.DETAILS;
